/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

export const TOP_CATEGORIES_DEPTH_LIMIT = '-1';
